import React from "react";
import "./App.css";
import "fontsource-roboto";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Home from "./components/home";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import CacheBuster from "./CacheBuster";

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Router>
              <Switch>
                <Route path="/" exact component={Home} />
                <Route path="*" component={Home} />
              </Switch>
            </Router>
          </MuiPickersUtilsProvider>
        );
      }}
    </CacheBuster>
  );
}

export default App;
